import React from 'react';
import { Link } from 'react-router-dom';
import { Star, BadgeCheck } from 'lucide-react';

export default function LawFirmCard({ firm, compact = false }) {
  const whatsappUrl = firm.whatsapp ? `https://wa.me/${firm.whatsapp}?text=${encodeURIComponent('Olá! Encontrei seu escritório no Ambito Advogados e gostaria de uma consulta.')}` : null;
  const profile = `/escritorio/${firm.slug}`;

  return (
    <article className="group bg-white rounded-[10px] border border-[#cbd8dc] hover:border-[#547a83] transition-colors flex flex-col overflow-hidden" data-testid={`firm-card-${firm.slug}`}>
      <Link to={profile} className="block overflow-hidden bg-[#f2f6f7]" aria-label={firm.name}>
        <div className="aspect-[4/3] overflow-hidden">
          <img src={firm.photo} alt={firm.leadLawyer || firm.name} loading="lazy" className="w-full h-full object-cover" />
        </div>
      </Link>

      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center justify-between gap-2">
          <span className="aj-kicker">{firm.cityName}/{firm.state}</span>
          {firm.verified && (
            <span className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#153e44]"><BadgeCheck className="w-4 h-4 text-[#0a7d3e]" aria-hidden="true" /> OAB</span>
          )}
        </div>
        <h3 className="text-[20px] leading-[1.35] mt-2 mb-1">
          <Link to={profile} className="text-[#122f36] hover:text-[#063f4c] underline underline-offset-[0.18em] decoration-[0.075em] decoration-[#cbd8dc] hover:decoration-[#063f4c]">{firm.name}</Link>
        </h3>
        {(firm.leadLawyer || firm.oab) && <p className="text-[15px] text-[#52676e] m-0 line-clamp-1">{[firm.leadLawyer, firm.oab].filter(Boolean).join(' • ')}</p>}

        <div className="flex items-center gap-1.5 mt-2 text-[15px] text-[#425a62]">
          {firm.reviews > 0 ? (<>
            <Star className="w-4 h-4 fill-[#153e44] text-[#153e44]" aria-hidden="true" />
            <span className="font-semibold text-[#243b42]">{firm.rating.toFixed(1)}</span>
            <span>({firm.reviews} {firm.reviews === 1 ? 'avaliação' : 'avaliações'})</span>
          </>) : <span>Sem avaliações ainda</span>}
        </div>

        {!compact && firm.categories?.length > 0 && (
          <p className="text-[15px] text-[#425a62] mt-2 mb-0 line-clamp-1">
            {firm.categories.slice(0, 3).map(c => c.replace(/-/g, ' ')).join(' · ')}
          </p>
        )}

        <div className="mt-auto pt-4 flex items-center justify-between gap-3">
          <Link to={profile} className="aj-link text-[16px] py-2 inline-block">Ver perfil →</Link>
          {whatsappUrl && (
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-[15px] font-semibold text-[#075a6d] hover:text-[#063f4c] underline underline-offset-[0.18em]">WhatsApp</a>
          )}
        </div>
      </div>
    </article>
  );
}
